<app-banner [heading]="'ADMISSIONS PROCESS'" [detail]="'ACHIEVING HIGH STANDARDS'"></app-banner>

<main id="main">
	
	
    <!-- ======= Features Section ======= -->
   <section id="features" class="features">
     <div class="container">

       <div class="row feature-item">

         <div class="col-lg-12  pt-5 pt-lg-0">
           <h4>Admission Procedure</h4>
           <p>
             Dedicated to create, re-shape, model and catalyze the academics excellence, we have following admission procedure :
           </p>
               <ul>

                         <li>The admission process starts on 1st December every year. 
                         The admission registration form can be downloaded from school's website/ availed from school's reception counter.
                               
                         </li>
                         <li>Parents are expected to submit the admission registration form either on school's website (online submission)
                         OR submit the duly filled admission registeration form at the school's reception counter (offline submission).
                               
                         </li>
                         <li>The entrance test syllabus will be provided alongwith the test date at the time of submission. 

                         </li>
                         <li>The information regarding the list of selected candidates can be obtained from 
                         School's website/School's reception counter.
                           
                         </li>
                         <li>Admission test paper will not be shown or shared with the parents and the decision of admission committee of school will be final.</li>
                         <li>School visit for the parents can be arranged within the scheduled time-frames organised by the school.</li>
               </ul> 
               <br><br><br>
                   <h6><b></b></h6>
                   <h6><b>Principal</b></h6>
                   <h6><b>Tagore Global School</b></h6>  
                   
         </div>
          
         
       </div>
     </div>
   </section><!-- End Features Section -->
 </main>